import React, { Component } from 'react';
import { injectIntl } from "react-intl";
import { connect } from 'react-redux';
import { patchPricingTableItem } from '../../state/pricing/actions';
import { getPricingTableItem } from '../../state/pricing/selectors';
import ActionButton from "../button/actionbutton.component.jsx";
import Icon from "../icon/icon.component.jsx";
const uuidv4 = require('uuid/v4')

class QuoteItemInternalNotesEdit extends Component {
    constructor(props, context) {
        super(props, context)

        this.state = {
            text: this.props.item?.attributes.internalNotes,
            className: this.props.className,
            value: this.props.item?.attributes.internalNotes,
            uniqueId: uuidv4(),
            editable: this.props.editable || false,
            editMode: false,
            hover: false,
        }
        this.handleFormChange = this.handleFormChange.bind(this)
        this.triggerEdit = this.triggerEdit.bind(this)
        this.save = this.save.bind(this)
        this.onMouseEnterHandler = this.onMouseEnterHandler.bind(this)
        this.onMouseLeaveHandler = this.onMouseLeaveHandler.bind(this)
    }


    componentWillReceiveProps(nextProps) {
        this.setState({
            text: nextProps.item?.attributes.internalNotes,
            value: nextProps.item?.attributes.internalNotes,
        })
    }

    componentDidMount() { }

    onMouseEnterHandler() {
        this.setState({
            hover: true
        });
    }

    onMouseLeaveHandler() {
        this.setState({
            hover: false
        });
    }

    triggerEdit(event) {
        event?.preventDefault()
        this.setState({
            editMode: !this.state.editMode
        })
    }

    handleFormChange(event) {
        this.setState({
            text: event.target.value
        })
    }

    save(event) {
        event.preventDefault()
        this.props.dispatch(patchPricingTableItem(this.props.itemId, this.props.mainObjectId, this.props.type, {
            internalNotes: this.state.text,
            mainObjectId: this.props.mainObjectId,
        }, false, false))

            this.setState({
                editMode: false,
            })
        
    }

    render() {
        let link = <a href={'#'} onClick={this.triggerEdit} className={'btn btn-sm btn-outline-primary'}>
            <Icon value={'quote-right'} />
        </a>
        return <span className={this.state.className}>
            {this.props.editable && link}
            <div className={"dropdown-menu p-4 " + (this.state.editMode ? 'show' : '')} style={{ width: '350px', left: "auto", top: "auto" }}>
                <div className="w-100 m-0">
                    <textarea
                        value={this.state.text}
                        onChange={this.handleFormChange}
                        rows="5"
                        className="form-control"
                    />
                </div>
                <p className="m-0 pt-2">
                    <button className="btn btn-sm btn-outline-secondary" onClick={this.triggerEdit}>
                        <Icon value={"arrow-left"} />
                    </button>
                    <ActionButton className="btn btn-sm btn-outline-primary ml-2" onClick={this.save} loadingTimeout={2000}>
                        <Icon value={"save"} />
                    </ActionButton>
                </p>
            </div>
        </span>
    }

}

const mapState = (state, props) => {
    const id = props.itemId
    const objectId = props.mainObjectId
    const item = getPricingTableItem(state, id, objectId)
    return {
        ...props,
        item: item,
    }
}

export default connect(mapState)(injectIntl(QuoteItemInternalNotesEdit))






// WEBPACK FOOTER //
// ./src/common/quote/iteminternalnotes.component.jsx